import _extends from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import styles from '../../components/styles/elements/FullPopup.module.scss';

var withFullPopup = function withFullPopup(Component) {
  return function withFullPopup(props) {
    var title = props.title,
        passedProps = _objectWithoutProperties(props, ["title"]);

    var closePopup = passedProps.closePopup;
    return __jsx("div", {
      className: styles.root
    }, __jsx("div", {
      className: "d-flex justify-content-between align-items-center"
    }, __jsx(Link, {
      href: "/",
      passHref: true
    }, __jsx("a", {
      className: styles.logo
    }, __jsx(Image, {
      src: "/images/icons/conso.png",
      width: 111,
      height: 33,
      alt: "Conso"
    }))), __jsx("div", {
      className: styles.close,
      onClick: closePopup
    }, __jsx(FontAwesomeIcon, {
      className: "mr-2",
      icon: faTimes,
      height: "16",
      width: "16"
    }), "\xCEnchide")), __jsx("div", {
      className: "".concat(styles.header, " ")
    }, title), __jsx(Component, _extends({}, passedProps, {
      closePopup: closePopup
    })));
  };
};

export default withFullPopup;